import React, { createContext, useContext } from 'react';
import Loader from '../common/Loader';
import { getConfiguration, getTimezoneOffset } from '../data/utils';
import { parseTimelineData } from '../data/parseTimelineData';
import { useFetch } from '../data/fetch/useFetch';

export const TimelineContext = createContext(null);

export function useTimeline() {
    return useContext(TimelineContext);
}


export default function TimelineProvider(props) {

    const conf = getConfiguration();
    const [isLoading, isError, data] = useFetch(conf.api.getTimelinePalinsestiDelGiorno, { timezone: getTimezoneOffset() }, (data) =>{
       return parseTimelineData(data)
    }
    );
    if (isLoading || isError) {
        return (
            <>
                <div></div>
                <Loader />
            </>
        );
    }

    return (
        <TimelineContext.Provider value={data}>
          {props.children}
        </TimelineContext.Provider>
    );
}
